import React from 'react';
import '../styles/services.css';

const SERVICES = [
  {
    icon: '📊',
    title: 'Geotechnical Monitoring (Singapore)',
    desc: 'Settlement markers, inclinometers, piezometers, and strain gauges installed and monitored for deep excavation, tunnelling, and foundation works.',
    tags: ['Settlement', 'Inclinometer', 'Piezometer'],
  },
  {
    icon: '🔊',
    title: 'Environmental Noise Monitoring (Singapore)',
    desc: 'NEA-compliant real-time noise monitoring stations with automated alert systems and regulatory reporting for construction sites.',
    tags: ['NEA Approved', 'Real-Time Alerts', 'Auto-Reports'],
  },
  {
    icon: '🌊',
    title: 'Vibration Monitoring (Singapore)',
    desc: 'Tri-axial vibration sensors for blast, pile-driving, and heavy machinery operations — protecting adjacent structures and heritage buildings.',
    tags: ['Pile Driving', 'Blasting', 'PPV Compliance'],
  },
  {
    icon: '🗼',
    title: 'Structural Health Monitoring',
    desc: 'Continuous monitoring of bridges, retaining walls, and buildings using tiltmeters, crack gauges, and load cells for long-term structural assessment.',
    tags: ['Bridges', 'Retaining Walls', 'Load Cells'],
  },
  {
    icon: '📡',
    title: 'IoT Sensor Networks',
    desc: 'Wireless multi-point sensor networks using LoRa, 4G, and fibre backhaul — designed for remote or congested urban construction sites.',
    tags: ['LoRa', '4G/LTE', 'Mesh Network'],
  },
  {
    icon: '☁️',
    title: 'Data Services & Reporting',
    desc: 'Secure cloud data storage, automated threshold alerting, PDF report generation, and data export for consultant review and regulatory submission.',
    tags: ['Cloud Storage', 'Auto Alerts', 'PDF Reports'],
  },
];

const Services: React.FC = () => {
  return (
    <section id="services" className="cv-services">
      <div className="cv-container">
        <div className="cv-section-header">
          <span className="cv-section-tag">What We Do</span>
          <h2 className="cv-section-title">Comprehensive Monitoring Services</h2>
          <p className="cv-section-subtitle">
            From sensor design and installation through to live data management and regulatory
            reporting, CoreVision provides the full monitoring lifecycle for complex infrastructure projects.
          </p>
        </div>

        <div className="cv-services__grid">
          {SERVICES.map((s) => (
            <div className="cv-service-card" key={s.title}>
              <span className="cv-service-card__icon">{s.icon}</span>
              <h3 className="cv-service-card__title">{s.title}</h3>
              <p className="cv-service-card__desc">{s.desc}</p>
              <div className="cv-service-card__tags">
                {s.tags.map((t) => (
                  <span className="cv-tag" key={t}>{t}</span>
                ))}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Services;
